import {
  Line,
  mixins
} from "vue-chartjs";

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['measurement', 'showInLabel'],
  data: function() {
    return {
      options: {
        legend: {
          display: true,
          labels: {
            filter: function(legendItem, chartData) {
              return (chartData.datasets[legendItem.datasetIndex].label != "Min" && chartData.datasets[legendItem.datasetIndex].label != 'Max' )
            },
          }
        },
        hover: { mode: 'x' },
        plugins: {
          filler: {
            propagate: false
          }
        },
        maintainAspectRatio: false,
        responsive: true,
        elements: {
          point: { radius: 2 },
        },
        tooltips: {
          mode: 'x',
          intersect: true,
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label += ': ';
              }
              label += tooltipItem.yLabel.toFixed(1);
              return label;
            }
          },
        },
        scales: {
          xAxes: [{
            type: "time",
            distribution: 'series',
            display: true,
            time: {
              unit: 'day',
              displayFormats: {
                hour: "DD MMM YYYY"
              },
              tooltipFormat: "DD MMM YYYY., HH:mm"
            },
            scaleLabel: {
              display: true,
            }
          }],
          yAxes: [{
            scaleLabel: {
              labelString: 'Temperature (°C)',
              display: true,
            },
            ticks: {
              callback: function(value) {
                return value + "°C";
              }
            },
            display: true
          }]
        }
      }
    }
  },
  mounted() {
    let UMeasure = ' mm'
    let yLabel = 'Precipitations (mm)'
    if (this.measurement == 'temperature') {
      UMeasure = ' °C'
      yLabel = 'Temperature (°C)'
    }
    this.options.scales.yAxes[0].ticks = {
      callback: function(value) {
        return value + UMeasure;
      }
    }
    this.options.scales.yAxes[0].scaleLabel.labelString = yLabel

    if(this.showInLabel == 'day'){
      this.options.scales.xAxes[0].time.displayFormats.hour = "DD MMM"
      this.options.scales.xAxes[0].time.tooltipFormat = "DD MMM"
    } else if(this.showInLabel == 'month'){
      this.options.scales.xAxes[0].time.displayFormats.day = "MMM"
      this.options.scales.xAxes[0].time.tooltipFormat = "MMM"
    } else {
      this.options.scales.xAxes[0].time.displayFormats.hour = "DD MMM YYYY"
      this.options.scales.xAxes[0].time.tooltipFormat = "DD MMM. YYYY, HH:mm"
    }
    this.renderChart(this.chartData, this.options);
  }
};
